import get from 'lodash/get';
<template>
  <el-drawer
    title="Contratos Activos"
    :visible.sync="visible"
    direction="rtl"
    size="50%"
    @close="onDrawerClose"
  >
    <el-row> </el-row>
    <rabbey-table-3
      :data="ActiveContractsData"
      :columns="activeContractsColumns"
    />
  </el-drawer>
</template>

<script>
export default {
  name: "CashFlowActiveContractsDetails",
  props: {
    activeContracts: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ActiveContractsData: [],
      activeContractsColumns: [
        {
          label: "Contrato",
          prop: "NoContrato",
          "min-width": "150px"
        },
        {
          label: "Cliente",
          prop: "clientName",
          "min-width": "150px"
        },
        {
          label: "Monto",
          prop: "TotalMensual",
          "min-width": "150px"
        },
        {
          label: "Estado",
          prop: "statusContract",
          "min-width": "150px"
        },
        {
          label: "Fecha Final",
          prop: "EndDate",
          "min-width": "150px"
        }
      ]
    };
  },
  created() {
    this.getActiveContracts();
  },
  methods: {
    async getActiveContracts() {
      this.$http
        .get("/api/CashFlow/GetRowCashflowFromContractsDetails")
        .then((resp) => {
          this.ActiveContractsData = resp.data;
          //console.log(this.ActiveContractsData)
        })
        .catch((err) => {
          throw err;
        });
      //this.ActiveContractsData = this.activeContracts
    },
    onDrawerClose() {
      this.$emit("updateVisible", false);
    }
  },
  watch: {
    activeContracts(val) {
      if (val === true) {
        this.getActiveContracts();
      }
    }
  }
};
</script>

<style></style>
